import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  newPayment(event) {
    event.preventDefault();
    const url = this.data.get("redirectUrl"),
      gatewayCode = this.data.get("gatewayCode"),
      showAmountModal = this.data.get("showAmountModal"),
      amount = this.data.get("amount");

    if (showAmountModal == "true") {
      $("#payment-amount-modal").modal({
        show: true,
        backdrop: "static",
        keyboard: false
      });
      applyBrandStyles();
    } else {
      window.location = url;
    }
  }

  newPaymentWithAmount(event) {
    event.preventDefault();
    const url = this.data.get("redirectUrl");
    const form = this.formTarget;
    const amount = $("input.amount").val();
    const setupDirectDebit = $("#sign_up_direct_debit").is(":checked")

    if (checkAmount(form)) {
      let redirectUrl = new URL(url, window.location.origin);

      redirectUrl.searchParams.set('amount', amount);
      redirectUrl.searchParams.set('sign_up_direct_debit', setupDirectDebit);
      window.location = redirectUrl;
    }
  }

  sendPaymentReceipt(event) {
    event.preventDefault();

    const form = this.formTarget;
    const redirectURL = this.data.get("redirectUrl");

    hideModal("#payment-result-modal");
    $(".payment-details-container .spinner-container").show();

    axios
      .patch(form.action, $(form).serialize())
      .then(response => {
        this.notifySuccessReceipt(redirectURL, response.data.message)
      })
      .catch(error => {
       this.notifyFailedReceipt(redirectURL)
      });
  }

  sendPaymentReceiptFromHotwireModal(event) {
      event.preventDefault();

      const form = this.formTarget;
      const redirectURL = this.data.get("redirectUrl");

      if(form.checkValidity()) {
        $(".payment-result-spinner").show()
        $(".payment-success-container").hide()

        axios
          .patch(form.action, $(form).serialize())
          .then(response => {
            this.notifySuccessReceipt(redirectURL, response.data.message);
            closeHotwireModal(event);
          })
          .catch(error => {
            this.notifyFailedReceipt(redirectURL);
            closeHotwireModal(event);
          });
      }
    }

  paymentFailedRedirect(event) {
    event.preventDefault();
    const redirectURL = this.data.get("redirectUrl");

    if (parent.frames.length > 0) {
      window.parent.location = redirectURL;
    } else {
      window.parent.location = redirectURL;
    }
  }

  notifySuccessReceipt(redirectURL, message) {
    bootbox.alert({
      title: "<i class='fa fa-check-circle success-icon'></i>Success",
      message: message,
      className: "success-modal",
      callback: function () {
        $(".modal-header").addClass("bg-success");
        if (parent.frames.length > 0) {
          window.parent.location = redirectURL;
        } else {
          window.parent.location = redirectURL;
        }
      },
      closeButton: false
    });
  }

  notifyFailedReceipt(redirectURL) {
    bootbox.alert({
      title: "<i class='fa fa-exclamation-triangle failed-icon'></i>Failed",
      message: "Failed to send receipt, please contact your service provider for details.",
      className: "failure-modal",
      callback: function () {
        $(".modal-header").addClass("bg-warning");
        if (parent.frames.length > 0) {
          window.parent.location = redirectURL;
        } else {
          window.parent.location = redirectURL;
        }
      },
      closeButton: false
    });
  }
}
